import React from 'react';

const DispositivoLegalContext = React.createContext();

export default DispositivoLegalContext;
